import React, { useState, useEffect } from 'react';
import { InstanceList } from './InstanceList';
import { Auth } from './Auth';
import { authService } from '../services/auth';
import { IconLogout, IconTerminal } from './Icons';

export const Admin: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = authService.getAuthToken();
    if (token) {
      setIsAuthenticated(true);
    }
  }, []);

  const handleAuth = async (key: string) => {
    try {
      const response = await fetch('/api/auth/verify', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ key })
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error || 'Ошибка авторизации');
      }

      const { token } = await response.json();
      authService.setAuthToken(token);
      setIsAuthenticated(true);
      setError(null);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Ошибка авторизации';
      setError(errorMessage);
    }
  };

  const handleLogout = () => {
    authService.removeAuthToken();
    setIsAuthenticated(false);
  };

  if (!isAuthenticated) {
    return <Auth onAuth={handleAuth} />;
  }

  return (
    <div className="admin-shell">
      <header className="admin-navbar">
        <div className="navbar-brand">
          <div className="brand-logo-mark">
            <IconTerminal size={18} />
          </div>
          <div>
            <div className="brand-title-row">
              <h1 className="brand-title">MIMIC AI</h1>
              <span className="brand-badge-tag">ENTERPRISE</span>
            </div>
            <span className="brand-sub">Автономная платформа управления AI-персонами</span>
          </div>
        </div>

        <div className="navbar-user-actions">
          <div className="admin-status-indicator">
            <span className="indicator-live-dot"></span>
            <span>СИСТЕМА АКТИВНА</span>
          </div>
          <button type="button" onClick={handleLogout} className="btn btn-logout" title="Выйти из системы">
            <IconLogout size={14} />
            <span>Выйти</span>
          </button>
        </div>
      </header>

      <main className="admin-main-content">
        <InstanceList />
      </main>
    </div>
  );
};